import { ReactComponent as IndicatorIcon } from '../../icons/indicator.svg';
import './SellerThresholdIndicator.scss';

interface Props {
  amount: number;
}

const getPosition = (amount: number) => {
  const percent = amount >= 0 ? Math.round(amount / 333.33) : 0;

  if (percent > 100) {
    return `calc(100% - 5px)`;
  }

  if (percent <= 0) {
    return '-5px';
  }

  return `${percent}%`;
};

export default function SellerThresholdIndicator({ amount }: Props) {
  return (
    <div className='SellerThresholdIndicator w-100 position-relative mt-4'>
      <div
        className='SellerThresholdIndicator__point position-absolute'
        style={{
          left: getPosition(amount),
        }}
      >
        <IndicatorIcon />
      </div>
    </div>
  );
}
